module.exports = __webpack_public_path__ + "static/media/FET.930fc19a.svg";